import React from "react";
import Modal from "./Modal/modal";
import DropdownExport from "./Dropdown/dropdownExport";
import DropdownSpecifications from "./Dropdown/dropdownSpecifications";
import ChartRadar from "./Chart/Chart";

function Chart2() {
  const [selectedData, setSelectedData] = React.useState([]);
  const addLabel = (label) => setSelectedData([...selectedData, label]);
  const removeLabel = (label) => {
    let a = [...selectedData];
    a.splice(a.indexOf(label), 1);
    setSelectedData(a);
  };
 

  // console.log(selectedData);

  return (
    <>
      <div className="header-action">
        <div className="header-action-modal">
          <Modal />
        </div>
        <div className="header-action-dropdown">
          <div className="header-action-export">
            <DropdownExport />
          </div>
          <div className="header-action-sidebar">
            <DropdownSpecifications
              selectedData={selectedData}
              addLabel={addLabel}
              removeLabel={removeLabel}
            />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="section_chart">
           
            <ChartRadar selectedData={selectedData} />
          </div>
        </div>
      </div>
    </>
  );
}

export default Chart2;
